import React from "react";

import { createRoot } from 'react-dom/client';

import { initGA } from "components/GoogleTracking";

import MainApp from "./MainApp";
// import { server } from "./mocks/server";

initGA("UA-144019247-3");

const root = createRoot(document.getElementById("app-site"));

root.render(<MainApp />);